import { useEffect, useRef } from "react";

/**
 * Mirrors the latest value into a ref that is updated after every render. Use it to read
 * fresh props/state from long-lived async callbacks (timers, polling, subscriptions) without
 * re-creating the callback or capturing a stale closure.
 */
export const useLatestRef = <T>(value: T): { readonly current: T } => {
    const ref = useRef(value);
    useEffect(() => {
        ref.current = value;
    });
    return ref;
};
